



















import { isString } from 'lodash-es';
import { defineComponent, PropType, ref } from '@vue/composition-api';
import { SortingModel } from '~/modules/catalog/category/composables/useFacet/sortingOptions';
import CategoryFilters from './Filters/CategoryFilters.vue';
import CategoryBreadcrumbs from '~/modules/catalog/category/components/breadcrumbs/CategoryBreadcrumbs.vue';
import type { Aggregation } from '~/modules/GraphQL/types';

export default defineComponent({
  name: 'CategoryInfos',
  props: {
    categoryName: {
      type: String,
    },
    totalResults: {
      type: Number
    },
    catUid: {
      type: String,
    },
    term: {
      type: String
    },
    filterCode: {
      type: String
    },
    filters: {
      type: Array as PropType<Aggregation[]>
    },
    allIds: {
      type: Array as () => string[],
    },
    close: {
      type: Function,
      required: true
    },
    reloadProducts: {
      type: Function,
      required: true
    },
    categoryDescription: {
      type: String
    },
    sortBy: {
      type: Object as PropType<SortingModel>,
      required: true,
    },
    isSearch: {
      type: Boolean
    },
    preselectedSort: {
      type: String,
      required: false
    },
    hideFilterCodes: {
      type: Array as () => string[],
      required: false,
      default: () => []
    }
  },
  methods: {
    onChangeSorting(sort: string) {
      this.$emit('changeSorting', sort)
    },
    toggleFilterSidebar() {
      this.$props.close();
    },
    onReloadProducts() {
      this.$props.reloadProducts();
    },
    filtersReady() {
      /** 
       * Funny function: this is to avoid the flicker effect on the filters.
       * Because filterCode is fetched after the rendering of the whole component.
       * So better wait that is populated as string, empty or not, and it start as 'null'.
       * Maybe another solution could handle the flow of the different fetches to get the correct data in order.
       * But for the moment, i'm just running too fast man :(
      */
      return isString(this.$props.filterCode)
    }
  },
  components: {
    CategoryFilters,
    CategoryBreadcrumbs
  }
})
